import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, ChipProps } from '@mui/material';

type NewTagProps = Omit<ChipProps, 'color' | 'label' | 'multiline'>;

export const NewTag: FC<NewTagProps> = props => {
  const { t } = useTranslation();
  return <Chip color='info' label={t('new').toLocaleUpperCase()} variant='outlined' {...props} />;
};
